import { checkinHardware } from "@/lib/snipeit/hardware";
import { useMutation } from "@tanstack/react-query";
import { useLocation } from "wouter";

export function useCheckinHardware() {
  const [, navigate] = useLocation();

  return useMutation({
    mutationFn: ({ assetId, locationId, statusId }: { assetId: number; locationId?: number; statusId?: number }) =>
      checkinHardware(assetId, locationId, statusId),
    onSuccess: () => navigate("/"),
  });
}
